import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const STAMPS_PER_REWARD = 10;

const TOKEN_KEY = "miro_gestore_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authCfg = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const photoSrc = (url) => `${BACKEND_URL}${url}`;

export const api = {
  // Public (customer-facing)
  createCustomer: (name, phone) =>
    axios.post(`${API}/customers`, { name, phone }).then((r) => r.data),
  getByPhone: (phone) =>
    axios.get(`${API}/customers/phone/${encodeURIComponent(phone)}`).then((r) => r.data),
  createReservation: (data) =>
    axios.post(`${API}/reservations`, data).then((r) => r.data),

  // Gestore auth
  pinLogin: (pin) => axios.post(`${API}/auth/pin-login`, { pin }).then((r) => r.data),
  verifyGestore: () => axios.get(`${API}/auth/verify`, authCfg()).then((r) => r.data),

  // Gestore-only (protected)
  listCustomers: () => axios.get(`${API}/customers`, authCfg()).then((r) => r.data),
  addStamp: (id) => axios.post(`${API}/customers/${id}/stamp`, {}, authCfg()).then((r) => r.data),
  removeStamp: (id) => axios.post(`${API}/customers/${id}/remove-stamp`, {}, authCfg()).then((r) => r.data),
  redeem: (id) => axios.post(`${API}/customers/${id}/redeem`, {}, authCfg()).then((r) => r.data),
  deleteCustomer: (id) => axios.delete(`${API}/customers/${id}`, authCfg()).then((r) => r.data),
  stats: () => axios.get(`${API}/stats`, authCfg()).then((r) => r.data),
  listReservations: () => axios.get(`${API}/reservations`, authCfg()).then((r) => r.data),
  updateReservation: (id, status) =>
    axios.patch(`${API}/reservations/${id}?status=${status}`, {}, authCfg()).then((r) => r.data),
  deleteReservation: (id) =>
    axios.delete(`${API}/reservations/${id}`, authCfg()).then((r) => r.data),

  // Photos
  submitPhoto: (formData) => axios.post(`${API}/photos`, formData).then((r) => r.data),
  ownerUploadPhoto: (formData) => axios.post(`${API}/photos/owner`, formData, authCfg()).then((r) => r.data),
  publicPhotos: () => axios.get(`${API}/photos/public`).then((r) => r.data),
  listPhotos: (status) =>
    axios.get(`${API}/photos${status ? `?status=${status}` : ""}`, authCfg()).then((r) => r.data),
  moderatePhoto: (id, status) =>
    axios.patch(`${API}/photos/${id}?status=${status}`, {}, authCfg()).then((r) => r.data),
  deletePhoto: (id) => axios.delete(`${API}/photos/${id}`, authCfg()).then((r) => r.data),
  viewPhoto: (id) => axios.post(`${API}/photos/${id}/view`, {}).then((r) => r.data),
  sharePhoto: (id) => axios.post(`${API}/photos/${id}/share`, {}).then((r) => r.data),
};
